/**
 * 课程内容
 * @description 课程内容
 * @author yly
 * @date 2023-9-12
 *  */
import React from 'react';
import { connect } from 'dva';
import ScheduleList from "./listSelect/scheduleList";
import ExamList from "./listSelect/examList";
import { Spin, Card, Row, Col, Divider, Form, Input } from 'antd'
import { AuditForm } from './components'

import { framework_tool, component_tool, utils_tool, } from '@/tool'
import { modelUtils } from "@/utils";
let { WizContainer, WizFileUpload } = framework_tool;
let {
  WizSelect,
  WizTreeSelectList, Wizmessage, WizForm, WizButton, WizModal, WizIcon, WizDropdown, WizMenu, WizTable, WizCustomSteps, WizAntdForm, WizBraftEditor

} = component_tool;
const WizItem = WizMenu.Item

class WizClassifySelect extends WizContainer {

  componentName = 'WizClassifySelect';

  constructor(props) {
    super(props);
    this.state = {
      stateSelects: props.initSelects || [],
      data: {},
      rowData: new Date().getTime(),
      programContent: [],
      selectedExamRows: [],//选择的课程考试
      selectedScheduleRows: [], //选择的课件
    }
    this.defaultValue = props.value;
  }

  static defaultProps = {
    onChange: () => { },//点击modal 确定的回调方法
    value: [],//已选数据,
    modalProps: {},//modal的参数
    selectProps: {},//输入框的参数
    wizTreeSelectListProps: {},//WizTreeSelectList的参数
    apiProps: {},//调用分类接口的参数
    apiPath: 'questionType/nodeList',//api的redux动态模型的请求patg
    returnKey: false,//onChange返回数据是否需要key，默认返回对象
  };


  /**
   * 初始化时根据record判断是新增还是编辑
   */
  _componentDidMount() {

    const { value } = this.props;
    if (value?.length > 0) {
      let copyValue = value.map(item => {
        return {
          name: item.name, orderNum: item.orderNum, fileType: item.fileType, fileName: item.fileName,
          contentType: item.contentType, fileId: item.fileId ? [{ fileId: item.fileId }] : [], address: item.address
        }
      })
      this.setState({ programContent: copyValue })
    }
    if (this.props.onClearContent) {
      this.props.onClearContent(this._onClear.bind(this))

    }
  }

  propsAndStateOnChange = {
    value: this._getValueOver.bind(this),
  }

  _getValueOver(nextProps, nextState) {
    const { value } = nextProps;
    if (value?.length > 0) {
      let copyValue = value.map(item => {
        return {
          name: item.name, orderNum: item.orderNum, fileType: item.fileType, fileName: item.fileName,
          contentType: item.contentType, fileId: item.fileId ? [{ fileId: item.fileId }] : [], address: item.address
        }
      })
      nextState.programContent = copyValue
      return true;
    } else {
    }
    return false;
  }

  /**
   * 重置
   */
  _onClear = () => {
    let value = this.defaultValue
    if (value?.length > 0) {
      let copyValue = value.map(item => {
        return {
          name: item.name, orderNum: item.orderNum, fileType: item.fileType, fileName: item.fileName,
          contentType: item.contentType, fileId: item.fileId ? [{ fileId: item.fileId }] : [], address: item.address
        }
      })
      this.setState({ programContent: copyValue })
    }
  }
  handleMenuClick(e) {
    let { programContent } = this.state
    let data = {}
    data.orderNum = programContent ? programContent.length + 1 : 1
    data.contentType = e.key === 'programAdd' ? 0 : 1
    data.fileType = 0
    this.setState({ scheduleModalVisible: true, data: data, addType: 'add' })
  }
  formatList = (content) => {
    let copyContent = JSON.parse(JSON.stringify(content))
    copyContent.forEach(item => {
      if (item.fileId) {
        item.fileId = item.fileId[0]?.fileId
      }
    })
    return copyContent
  }
  submit = (data) => {
    let { onChange } = this.props
    console.log('提交  =====>', data)
    let content = JSON.parse(JSON.stringify(this.state.programContent))
    if (content.findIndex(x => x.orderNum == data.orderNum) > -1) {
      let newIndex = content.findIndex(x => x.orderNum == data.orderNum)
      content.splice(newIndex, 1, data)
    } else {
      content.push(data)
    }
    this.setState({ programContent: content, scheduleModalVisible: false })
    let copyContent = JSON.parse(JSON.stringify(content))
    onChange && onChange(this.formatList(copyContent))
  }
  cancel = () => {
    this.setState({ scheduleModalVisible: false })
  }
  /**选择课件模态框 */
  scheduleListModal() {

    const { data, addType } = this.state
    return (
      <WizModal
        destroyOnClose={true}
        visible={this.state.scheduleModalVisible}
        onCancel={() => this.setState({ scheduleModalVisible: false })}
        footer={null}
        style={{ minWidth: 1000 }}
        title={`${!data.isRead ? addType == 'add' ? '新增' : '编辑' : '查看'}课程内容-${data.contentType == 0 ? '课件' : '考试'}`}
      >
        <AuditForm data={data} submit={this.submit} cancel={this.cancel} />
      </WizModal>
    )
  }

  editRecord = (record) => {
    record.isRead = false
    this.setState({ data: record, scheduleModalVisible: true, addType: 'edit' })
  }
  deleteRow = (record) => {
    let content = [...this.state.programContent]
    content = content.filter(x => x.orderNum != record.orderNum)
    this.setState({ programContent: this.rankList(content) })
  }
  rankList = (list) => {
    let copyList = JSON.parse(JSON.stringify(list))
    copyList.forEach((item, index) => {
      item.orderNum = index + 1
    })
    return copyList
  }
  lookRecord = (record) => {
    record.isRead = true
    this.setState({ data: record, scheduleModalVisible: true })
  }
  /**上移下移 行数据 */
  moveUpAndDown(record) {
    let { onChange } = this.props

    const programContent = [...this.state.programContent];

    const indexOf = programContent?.indexOf(record);
    // 是否上移
    const hasMoveUp = indexOf > 0

    console.log('moveUpAndDown --->', programContent, record, indexOf, hasMoveUp)
    if (!programContent?.length || (hasMoveUp && indexOf <= 0) || (!hasMoveUp && indexOf === programContent.length - 1)) {
      console.log('操作失败,请检查数据.可能原因无数据、已经到顶了、已经到底了')
      return;
    }
    // 数据位置替换
    programContent.splice(indexOf, 1)
    if (hasMoveUp) {
      programContent.splice(indexOf - 1, 0, record)
    } else {
      programContent.splice(indexOf + 1, 0, record)
    }
    // 重新计算排列顺序
    const neoProgramContent = programContent.map(({ orderNum, ...item }, index) => ({ ...item, orderNum: index + 1 }))
    // 保存变更到state
    this.setState({
      programContent: neoProgramContent,
      time: new Date().getTime()
    })
    onChange && onChange(this.formatList(neoProgramContent))

  }
  _render() {
    const menu = (
      <WizMenu onClick={this.handleMenuClick.bind(this)}>
        <WizItem key="programAdd">
          课件
        </WizItem>
        <WizItem key="examAdd">
          考试
        </WizItem>
      </WizMenu>
    );
    const columns = [
      {
        title: '排序',
        dataIndex: 'orderNum',
        key: 'orderNum',
        width: 60
      },
      {
        title: '课程内容名称',
        dataIndex: 'name',
        key: 'name',
        width: 120,
        ellipsis: true,
      },
      {
        title: '类型',
        dataIndex: 'contentType',
        key: 'contentType',
        width: 60,
        render: (text) => text == 0 ? '课件' : '考试'
      },
      {
        title: '内容类型',
        dataIndex: 'fileType',
        key: 'fileType',
        width: 100,
        render: (text) => text == 0 ? '文件' : '文件地址'
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        render: (text, record) => (
          <span>
            <a onClick={e => this.lookRecord(record)}> 查看</a>
            <a onClick={e => this.editRecord(record)}> 编辑</a>
            <a onClick={e => this.deleteRow(record)}> 删除</a>
            <Divider type="vertical" />
            <a onClick={e => this.moveUpAndDown(record)}> {record.orderNum == 1 ? '下' : '上'}移</a>
            <Divider type="vertical" />
          </span>
        ),
      },
    ];
    return (
      <>
        <WizDropdown overlay={menu}>
          <WizButton type="primary">
            新增课程内容 <WizIcon type="down" />
          </WizButton>
        </WizDropdown>
        <div className="table-row" key={'program_content_' + this.state.time}>
          <WizTable pagination={false} columns={columns} dataSource={this.state.programContent} />
        </div>
        {this.scheduleListModal()}
      </>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questionType } = state;
  const { apiProps } = ownProps;

  const treeData = modelUtils.getModelEntity(questionType, `questionType@treeData${apiProps && apiProps.type || ''}`);
  const load = modelUtils.getLoadingState(state, "selects");

  return {
    treeData,
    ...load
  }
};

const options = { withRef: true };
export default Form.create()(connect(mapStateToProps, null, null, options)(WizClassifySelect));

